import React, { useCallback } from 'react';
import { useExportsActions } from '../hooks/useExportsActions';
import ExportTemplate from './ExportTemplate';

const UserExports = () => {
  const { userExport } = useExportsActions();

  const sendExport = useCallback(async (exportData) => {
    if (!exportData) {
      return;
    }
    await userExport({ exportData });
  }, [userExport]);

  return (
    <ExportTemplate sendExport={sendExport} selectedCircle={true} />
  );
}

export default UserExports;
